import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
export default class RankingImage extends Component {
  view() {
    const imgUrl = app.forum.attribute("fof-gamification.topimage".concat(this.attrs.place, "Url"));
    const place = this.attrs.place;

    // Both branches return the same kind of node: the caller decides what
    // cell this sits in, and returning a <td> from one branch only used to
    // nest a cell inside a cell.
    return imgUrl ? m("img", {
      className: "rankings-image rankings-".concat(place),
      src: imgUrl,
      alt: ""
    }) : m(Icon, {
      name: "fas fa-trophy",
      className: "rankings-".concat(place)
    });
  }
}
flarum.reg.add('fof-gamification', 'forum/components/RankingImage', RankingImage);